(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["pk-emi-calculator"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('pk-emi-calculator')) {
  customElements.define('pk-emi-calculator', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.form = this.querySelector('form');
      this.money = new Intl.NumberFormat('en-IN', { style: 'currency', currency: 'INR', maximumFractionDigits: 0 });
      this.form.addEventListener('input', () => this.calculate());
      this.form.addEventListener('change', () => {
        const months = this.form.elements.unit.value === 'months';
        this.form.elements.tenure.max = months ? '600' : '50';
        this.calculate();
      });
      this.form.addEventListener('submit', event => { event.preventDefault(); this.calculate(); });
      this.form.addEventListener('reset', () => setTimeout(() => { this.form.elements.tenure.max = '50'; this.calculate(); }, 0));
      this.calculate();
    }
    calculate() {
      const f = this.form.elements;
      const p = Number(f.amount.value);
      const annual = Number(f.rate.value);
      const tenure = Number(f.tenure.value);
      const n = tenure * (f.unit.value === 'years' ? 12 : 1);
      const valid = f.amount.value !== '' && f.rate.value !== '' && f.tenure.value !== '' && Number.isFinite(p) && p >= 1 && p <= 1000000000 && Number.isFinite(annual) && annual >= 0 && annual <= 100 && Number.isInteger(tenure) && tenure >= 1 && n >= 1 && n <= 600;
      this.querySelector('#pk-emi-error').hidden = valid;
      [f.amount, f.rate, f.tenure].forEach(input => input.setAttribute('aria-invalid', String(!input.validity.valid)));
      if (!valid) {
        this.querySelectorAll('[data-emi],[data-principal],[data-interest],[data-total]').forEach(el => { el.textContent = '—'; });
        this.querySelector('[data-share]').style.width = '0%';
        return;
      }
      const r = annual / 1200;
      const emi = r === 0 ? p / n : p * r / -Math.expm1(-n * Math.log1p(r));
      const total = emi * n;
      const interest = Math.max(0, total - p);
      for (const [key, value] of Object.entries({emi,principal:p,interest,total})) this.querySelector('[data-' + key + ']').textContent = this.money.format(value);
      this.querySelector('[data-share]').style.width = (p / total * 100) + '%';
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["whatsapp-chat"] && !Shopify.designMode) return;
  try {
    (() => {
  let button = document.getElementById('pk-whatsapp-support');
  if (!button || button.dataset.ready) return;
  button.dataset.ready = 'true';
  document.querySelectorAll('#pk-whatsapp-support').forEach(node => {
    if (node !== button) node.remove();
  });
  const controls = '.sticky-atc,.pk-sticky,.pkhg-sticky,.scroll-to-top-btn,.music-player,.shopify-customer-privacy-banner,#shopify-pc__banner';
  const overlays = 'dialog[open],[aria-modal="true"],cart-drawer.active,.menu-drawer-container[open],.product-media-modal[open],.product-popup-modal[open],.popup-modal--active,.razorpay-container';
  let queued = false;
  const visible = node => {
    const style = getComputedStyle(node);
    const rect = node.getBoundingClientRect();
    return style.display !== 'none' && style.visibility !== 'hidden' && Number(style.opacity) !== 0 && rect.width > 0 && rect.height > 0 && rect.bottom > 0 && rect.top < innerHeight && rect.left < innerWidth && rect.right > 0;
  };
  function update() {
    queued = false;
    button = document.getElementById('pk-whatsapp-support');
    if (!button) return;
    button.dataset.ready = 'true';
    const hidden = [...document.querySelectorAll(overlays)].some(visible);
    if (button.hidden !== hidden) button.hidden = hidden;
    if (hidden) return;
    const gap = innerWidth <= 749 ? 12 : 16;
    const size = innerWidth <= 749 ? 46 : 48;
    const right = innerWidth - gap;
    let bottom = innerHeight - gap;
    const obstacles = [...document.querySelectorAll(controls)].filter(visible).filter(node => {
      const position = getComputedStyle(node).position;
      return position === 'fixed' || position === 'sticky';
    }).map(node => node.getBoundingClientRect()).sort((a,b) => b.top - a.top);
    for (const rect of obstacles) {
      if (rect.left < right && rect.right > right - size && rect.top < bottom + gap && rect.bottom > bottom - size - gap) bottom = rect.top - gap;
    }
    const lift = Math.max(0, Math.ceil(innerHeight - gap - bottom));
    if (button.style.getPropertyValue('--pk-wa-lift') !== lift + 'px') button.style.setProperty('--pk-wa-lift', lift + 'px');
  }
  function schedule() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(update);
  }
  addEventListener('scroll', schedule, {passive:true});
  addEventListener('resize', schedule, {passive:true});
  document.addEventListener('transitionend', schedule);
  document.addEventListener('animationend', schedule);
  new MutationObserver(schedule).observe(document.body, {subtree:true,childList:true,attributes:true,attributeFilter:['class','style','hidden','open','aria-hidden','data-show']});
  update();
})();
  } catch(e) { console.error(e); }
})();

})();
